export default __webpack_public_path__ + "static/media/ContactEdit.2fa97f31.svg";